<div class="container navtop">

    <h2 class="col-12 primary-font"><b>Gérer ma recharge</b></h2>

    <!-- spinner -->
    <!-- <div *ngIf="IsWait" class="col-12">
      <div class="row justify-content-center mt-4">
        <mat-spinner class="mt-5" strokeWidth="19" [diameter]="100" color="primary"></mat-spinner>
      </div>
    </div> -->


    <div *ngIf="stationDetail">


        <div class="row justify-content-center">
            <mat-card class="col-11 col-lg-7">
                <mat-card-content>

                    <!-- <mat-progress-bar class="row " *ngIf="loading" mode="indeterminate"></mat-progress-bar> -->
                    <h3 class="text-center"><b>Détails de la station</b></h3>

                    <h4 class="col-12"><b>{{stationDetail?.name}}</b></h4>



                    <h4 class="col-12">{{stationDetail?.street}}, {{stationDetail?.zipcode}}
                        {{stationDetail?.city}}</h4>

                    <h4 class="col-12">{{stationDetail?.price.description_price}}</h4>


                    <div class="row justify-content-center">

                        <img mat-card-image class="col-6" style="margin-bottom: 0px !important;"
                            [src]="sanitizeImageUrl('data:'+stationDetail?.image.mimetype+';base64,'+stationDetail?.image.file)"
                            alt="clem">


                    </div>


                </mat-card-content>
            </mat-card>



        </div>



        <form [formGroup]="formGroup">



            <!---------------------------------- Identifiant ---------------------------------------->
            <div class="row justify-content-center mt-4">
                <mat-card class="col-11 col-lg-7 bordure">
                    <mat-card-content>

                        <h2 class="row justify-content-center primary-font"><b>Code PIN</b></h2>


                        <!-- code pin -->
                        <div class="row justify-content-center">
                            <mat-form-field class="col-10">
                                <input matInput  placeholder="Code PIN Magique :" formControlName="pin"
                                [type]="hide ?  'password' : 'number'" required>
                                <mat-icon style="cursor: pointer" matSuffix (click)="hide = !hide">{{hide ?
                                    'visibility_off'
                                    :
                                    'visibility'}}</mat-icon>
                                <mat-error
                                    *ngIf="!formGroup.controls['pin'].valid || formGroup.controls['pin'].touched">
                                    {{ getErrorPin() }}
                                </mat-error>
                            </mat-form-field>
                        </div>




                    </mat-card-content>
                </mat-card>


            </div>




            <!-------------------------------- bouton ----------------------------------->
            <div class="row justify-content-center mt-4">
                <button class="col-11 col-md-3 primary-bouton " mat-raised-button color="primary" (click)="postPinBook()"
                    type="submit" type="submit">Suivant</button>
            </div>




        </form>


    </div>




    <h2 *ngIf="!stationDetail" class="text-center">Veuillez  rescanner  le QR code</h2>



</div>